import _slicedToArray from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import { __rest } from '../../../node_modules/.pnpm/@rollup_plugin-typescript@8.5.0_jm3lfwhp2n3nxb4wwf6zz565he/node_modules/tslib/tslib.es6.js';
import React__default from 'react';
import BackgroundModuleCss from './index.module.css.js';
import { composeCssClasses } from '../../../utils/composeCssClasses.js';
/**
 * Type definition for `BackgroundProps.backgroundAnimation`.
 */

var BackgroundAnimation;

(function (BackgroundAnimation) {
  BackgroundAnimation["FADE"] = "fade";
  BackgroundAnimation["ZOOM"] = "zoom";
})(BackgroundAnimation || (BackgroundAnimation = {}));

function Background(props) {
  var _props$backgroundAnim = props.backgroundAnimation,
      backgroundAnimation = _props$backgroundAnim === void 0 ? BackgroundAnimation.FADE : _props$backgroundAnim,
      backgroundImageClassName = props.backgroundImageClassName,
      backgroundImageBlendMode = props.backgroundImageBlendMode,
      backgroundImageSizes = props.backgroundImageSizes,
      backgroundImageSrcSet = props.backgroundImageSrcSet,
      backgroundImageSrc = props.backgroundImageSrc,
      backgroundImageAlt = props.backgroundImageAlt,
      backgroundImageStyle = props.backgroundImageStyle,
      _ = props.maskBackgroundBlendMode,
      _props$shouldLazyLoad = props.shouldLazyLoad,
      shouldLazyLoad = _props$shouldLazyLoad === void 0 ? true : _props$shouldLazyLoad,
      onLoad = props.onLoad,
      background = __rest(props, ["backgroundAnimation", "backgroundImageClassName", "backgroundImageBlendMode", "backgroundImageSizes", "backgroundImageSrcSet", "backgroundImageSrc", "backgroundImageAlt", "backgroundImageStyle", "maskBackgroundBlendMode", "shouldLazyLoad", "onLoad"]);

  var _React__default$useSt = React__default.useState(false),
      _React__default$useSt2 = _slicedToArray(_React__default$useSt, 2),
      isLoaded = _React__default$useSt2[0],
      setIsLoaded = _React__default$useSt2[1];

  var onLoadHandler = function onLoadHandler(event) {
    if (onLoad) onLoad(event);
    setIsLoaded(true);
  };
  /**
   * If there is no `backgroundImageSrc`, then there is no need to:
   * - Add the `Loading` class is not needed, instead the default class is `Loaded`.
   * - `img` tag element will not render.
   */


  var imageBackgroundClassNames = [];

  if (isLoaded) {
    imageBackgroundClassNames.push(BackgroundModuleCss.Loaded);

    switch (backgroundAnimation) {
      case BackgroundAnimation.ZOOM:
        imageBackgroundClassNames.push(BackgroundModuleCss.ZoomOut);
        break;

      case BackgroundAnimation.FADE:
        imageBackgroundClassNames.push(BackgroundModuleCss.FadeIn);
        break;
    }
  } else {
    imageBackgroundClassNames.push(BackgroundModuleCss.Loading);
  }

  return React__default.createElement("div", {
    className: composeCssClasses('hero-slider-slide-background', backgroundImageClassName, BackgroundModuleCss.Background),
    style: background
  }, React__default.createElement("img", {
    className: composeCssClasses.apply(void 0, ['hero-slider-slide-background-image', backgroundImageClassName, BackgroundModuleCss.Image].concat(imageBackgroundClassNames)),
    sizes: backgroundImageSizes,
    srcSet: backgroundImageSrcSet,
    src: backgroundImageSrc,
    alt: backgroundImageAlt,
    style: Object.assign({
      mixBlendMode: backgroundImageBlendMode
    }, backgroundImageStyle),
    onLoad: onLoadHandler,
    loading: shouldLazyLoad ? 'lazy' : 'eager'
  }));
}

export { BackgroundAnimation, Background as default };